/** Small inline banner when a React Query request fails. */
export function QueryErrorNote({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="rounded-lg border border-red-500/40 bg-red-500/10 px-3 py-2 text-xs text-red-200">
      <span>{message}</span>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="ml-2 font-semibold underline underline-offset-2"
        >
          Retry
        </button>
      ) : null}
    </div>
  );
}
